module.exports = __webpack_public_path__ + "media/images/squared-away-logo-vertical-b725ebcc918e27f63b3ce43c6c74a322.png";